import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { Image } from '../Image';
import { ClubR } from '@rakutenfrance/shared-svg';
import { transferSummaryHeaderStyles } from './PaymentSummaryHeader.style';
import { commonTransferStyles } from './Common.style';
export const PaymentSummaryHeader = () => {
    const commonTransferClasses = commonTransferStyles();
    const transferSummaryHeaderClasses = transferSummaryHeaderStyles();
    const headerContainerClasses = Object.assign(Object.assign({}, commonTransferClasses.commonContentContainer), transferSummaryHeaderClasses.headerContainer);
    const headerTextStyle = Object.assign(Object.assign({}, commonTransferClasses.commonText), commonTransferClasses.commonTextBold);
    return (React.createElement(Stack, { direction: "row", sx: headerContainerClasses },
        React.createElement(Paper, { sx: transferSummaryHeaderClasses.leftPaperContainer },
            React.createElement(Image, { imageUrl: "https://images.fr.shopping.rakuten.com/visuels/0_CLUB/images/clubRTransferRecap.png", styleCSS: {
                    margin: '0px',
                    objectFit: 'fill',
                    height: '55px',
                }, noImgSettings: {
                    width: '35px',
                    height: '35px'
                } }),
            React.createElement(Typography, { sx: headerTextStyle }, "R\u00E9capitulatif")),
        React.createElement(Paper, { sx: transferSummaryHeaderClasses.clubR },
            React.createElement(ClubR, { width: '56', height: '22' }))));
};
